import React, { useMemo } from 'react';

import { useAuth, useProductCatalogue } from './hooks';
import { ProductCatalogueContext } from './ProductCatalogueContext';

export const ProductCatalogueProvider = ({ children }) => {
  const { user } = useAuth();

  const enabled = !!user;

  const {
    data: catalogue,
    loading: catalogueLoading,
    error: catalogueError,
    start: startCatalogue,
  } = useProductCatalogue({
    enabled,
    lazy: true,
  });

  /** @type {import('./ProductCatalogueContext').ProductCatalogueContextReturn} */
  const value = useMemo(
    () => ({
      catalogue,
      catalogueLoading,
      catalogueError,
      enabled,
      startCatalogue,
    }),
    [catalogue, catalogueLoading, catalogueError, enabled, startCatalogue],
  );

  return <ProductCatalogueContext.Provider value={value}>{children}</ProductCatalogueContext.Provider>;
};
